// extracted by mini-css-extract-plugin
module.exports = {"phone-input":"forms_phone-input__fVQgF","phone-button":"forms_phone-button__LqntA"};